import React from 'react'
import EyefinitySectionFields from '../EyefinitySectionFields'

export default function FacilityAndBillingInformation(props) {
  return <EyefinitySectionFields {...props} sectionName="facility_and_billing_information" title="Facility And Billing Information" />
}
